/** @jsxImportSource theme-ui */

import React from "react"
import { Flex, Text, Box } from "theme-ui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import _ from "lodash"
import {
  faChevronUp,
  faEnvelope,
  faGlobe,
  faMapPin,
  faPhone
} from "@fortawesome/free-solid-svg-icons"

import * as Styles from "./BusinessInfoPreviewStyles"

const BusinessInfoPreview = ({
  themeColor,
  info,
  showOverflow,
  onChange,
  fontSize
}) => {

  return (
    <Styles.BusinessInfoContainer
      className="business-info-container"
      open={showOverflow}
      color={themeColor}
      fontSize={fontSize}
    >
      <Styles.BusinessInfo
        className="business-info"
        open={showOverflow}
      >
        <Styles.InfoContent className="info-content">
          <Flex pb={2} sx={{ justifyContent: "center" }}>
            <Styles.ProfilePic
              className="business-logo"
              size="72px"
              url={_.get(info, "profile.logoUrl")}
              color={themeColor}
            />
          </Flex>
          <Flex className="business-name" sx={{ justifyContent: "center", fontSize: "1.2em", fontWeight: "bold" }}>{info?.profile?.name}</Flex>
          <Flex className="business-legal-name" sx={{ justifyContent: "center" }}>{info?.profile?.legalName}</Flex>
          {!!info?.profile?.about &&
            <Styles.InfoCard>
              <Text className="business-about" sx={{ fontSize: "0.9em" }}>{info?.profile?.about}</Text>
            </Styles.InfoCard>
          }
          {!!info?.profile?.addresses?.length &&
            <Styles.InfoCard className="business-info-card">
              <FontAwesomeIcon
                icon={faMapPin}
                sx={{ marginRight: "16px" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                {info?.profile?.addresses.map((address, i) => {
                  return (
                    <Styles.InfoWrapper key={i}>
                      {address?.alias && <Styles.Info className="business-address-alias" bold color={themeColor}>{address?.alias}</Styles.Info>}
                      {address?.line1 && <Styles.Info className="business-address-line-1" color={themeColor}>{address?.line1}</Styles.Info>}
                      {address?.line2 && <Styles.Info className="business-address-line-2" color={themeColor}>{address?.line2}</Styles.Info>}
                      {address?.city && <Styles.Info className="business-address-city" color={themeColor}>{address?.city}</Styles.Info>}
                      {address?.state && <Styles.Info className="business-address-state" color={themeColor}>{address?.state}</Styles.Info>}
                      {address?.zip && <Styles.Info className="business-address-zip" color={themeColor}>{address?.zip}</Styles.Info>}
                      <div className="separator" />
                    </Styles.InfoWrapper>
                  )
                })}
              </Box>
            </Styles.InfoCard>
          }
          {!!info?.profile?.phones?.length &&
            <Styles.InfoCard className="business-info-card" >
              <FontAwesomeIcon
                icon={faPhone}
                sx={{ marginRight: "16px" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                {info?.profile?.phones.map((p, i) => {
                  if (p.number || p.alias) {
                    return (
                      <Styles.Info key={i}>
                        <Styles.InfoLink href={`tel:${p.number}`} target="_blank" rel="noopener noreferrer">
                          {!!p?.alias && <span sx={{ paddingRight: "8px", fontWeight: "bold", flexShrink: "0" }}>{p.alias}</span>}
                          <Styles.Text>{p.number}</Styles.Text>
                        </Styles.InfoLink>
                        <div className="separator" />
                      </Styles.Info>
                    )
                  }
                  return null
                })}
              </Box>
            </Styles.InfoCard>
          }
          {!!info?.profile?.emails?.length &&
            <Styles.InfoCard className="business-info-card" >
              <FontAwesomeIcon
                icon={faEnvelope}
                sx={{ marginRight: "16px" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                {info?.profile?.emails.map((e, i) => {
                  if (e.email || e.alias) {
                    return (
                      <Styles.Info key={i}>
                        <Styles.InfoLink href={`mailto:${e.email}`} target="_blank" rel="noopener noreferrer">
                          {!!e?.alias && <span sx={{ paddingRight: "8px", fontWeight: "bold", flexShrink: "0" }}>{e.alias}</span>}
                          <Styles.Text >{e.email}</Styles.Text>
                        </Styles.InfoLink>
                        <div className="separator" />
                      </Styles.Info>
                    )
                  }
                  return null
                })}
              </Box>
            </Styles.InfoCard>
          }
          {!!info?.profile?.websites?.length &&
            <Styles.InfoCard className="business-info-card" >
              <FontAwesomeIcon
                icon={faGlobe}
                sx={{ marginRight: "16px" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                {info?.profile?.websites.map((website, i) => {
                  if (website.website || website.alias) {
                    return (
                      <Styles.Info key={i}>
                        <Styles.InfoLink href={website?.url} target="_blank" rel="noopener noreferrer">
                          <div sx={{ paddingRight: "8px", fontWeight: "bold", flexShrink: "0" }}>{website?.alias}</div>
                          <Styles.Text>{website?.url}</Styles.Text>
                        </Styles.InfoLink>
                        <div className="separator" />
                      </Styles.Info>
                    )
                  }
                  return null
                })}
              </Box>
            </Styles.InfoCard>
          }
        </Styles.InfoContent>
        <Flex className="business-info-footer" sx={{ justifyContent: "center", height: "40px", alignItems: "center" }}>
          {showOverflow &&
            <FontAwesomeIcon
              className="business-info-close-button"
              sx={{ cursor: "pointer" }}
              icon={faChevronUp}
              fixedWidth
              onClick={() => {
                onChange(false)
              }}
            />
          }
        </Flex>
      </Styles.BusinessInfo>
    </Styles.BusinessInfoContainer>
  )
}

export default BusinessInfoPreview
